// extracted by mini-css-extract-plugin
export default {"root":"mwGUOt","blend":"O40q1L"};